import { Popover as BasePopover } from '@base-ui/react/popover'

import { withPopupOpenMarker } from '@gto/ui/state-markers'

export const Trigger = ({ className, ...props }: BasePopover.Trigger.Props) => {
  return (
    <BasePopover.Trigger
      delay={0}
      {...props}
      className={withPopupOpenMarker(className)}
    />
  )
}
